module.exports = __webpack_public_path__ + "img/q-img-2.a2665614.jpg";